import _ from "lodash";

export function isRtl() {
  return document.documentElement.getAttribute("dir") === "rtl"
}

export function isRtlLanguage(langCode) {
  return langCode === "ar" || langCode === "ur"
}

export const highLightStr = (str, fontSize = '18px', lineHight = '32px', fontWeight = 500, color = "#fff") => {
  const reg = new RegExp("<>[^<>/]+</>", "ig");
  let hightTips = str.replace(reg, (val) => {
    return `<span style=" font-size:${fontSize}; line-height:${lineHight}; font-weight:${fontWeight};color:${color}">${val.substring(
      2,
      val.length - 3
    )}</span>`;
  });
  return hightTips;
};
